import { useSx, View } from 'dripsy';
import { MotiView } from 'moti';
import { useContext, useEffect, useState } from 'react';
import { ViewStyle } from 'react-native';
import { Easing } from 'react-native-reanimated';

import { AnimatingCircleContext } from './AnimatingCircleContext';

export default function AnimatingCircle({
  id,
  style,
}: {
  id: string;
  style?: ViewStyle;
}) {
  const [isAfterDelay, setIsAfterDelay] = useState(false);
  const { targetId } = useContext(AnimatingCircleContext);
  const sx = useSx();

  const isVisible = targetId === id;

  useEffect(() => {
    if (isVisible) {
      setIsAfterDelay(false);
      const timeoutId = setTimeout(() => {
        setIsAfterDelay(true);
      }, 2000);
      return () => {
        clearTimeout(timeoutId);
      };
    }
    return;
  }, [isVisible]);

  if (!isVisible || !isAfterDelay) {
    return null;
  }

  return (
    <View
      sx={{
        position: 'absolute',
        inset: 0,
        justifyContent: 'center',
        alignItems: 'center',
        pointerEvents: 'none',
      }}
    >
      <MotiView
        style={[
          sx({
            position: 'fixed',
            backgroundColor: 'animatingCircle',
            width: 160,
            height: 160,
            borderRadius: 80,
          }),
          style,
        ]}
        animate={{
          scale: [
            0,
            { value: 0.5, duration: 500, type: 'timing' },
            { value: 1, duration: 500, type: 'timing' },
            { value: 0, duration: 200, type: 'timing' },
          ],
          opacity: [
            0,
            { value: 0.5, duration: 500, type: 'timing' },
            { value: 0, duration: 500, type: 'timing' },
            { value: 0, duration: 200, type: 'timing' },
          ],
        }}
        transition={{
          type: 'timing',
          easing: Easing.linear,
          loop: true,
        }}
      />
    </View>
  );
}
